import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg border-b-4 border-h-primary-800 shadow-sm p-5 custom-card" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold text-lg break-words w-full" }
const _hoisted_4 = { class: "text-gray-500 my-3 flex items-center gap-1 flex-row" }
const _hoisted_5 = { class: "flex flex-row items-start gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "font-bold flex items-start"
}
const _hoisted_7 = { class: "font-extrabold w-20" }
const _hoisted_8 = {
  key: 0,
  class: "break-words max-w-full"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "flex justify-end items-center gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.question.prompt), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "mb-5"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (
                _ctx.question?.type === 'DEFAULT' || _ctx.question?.type === undefined
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_v_icon, {
                      name: `${
                  item?.id === _ctx.question?.correctItem?.id
                    ? 'hi-solid-check'
                    : 'hi-x'
                }`,
                      class: _normalizeClass(`${
                  item?.id === _ctx.question?.correctItem?.id
                    ? 'text-green-600'
                    : 'text-h-error-400'
                }`)
                    }, null, 8, ["name", "class"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.question?.type === 'TRUE_OR_FALSE')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: _normalizeClass([
                item?.correctAnswer
                  ? 'pi pi-check text-green-600'
                  : 'pi pi-times text-h-error-400',
                'mr-2',
              ])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_7, " Item " + _toDisplayString(_ctx.question?.type === "TRUE_OR_FALSE" ||
                _ctx.question?.type === undefined
                  ? _ctx.chooseLetter(i)
                  : i + 1) + ": ", 1)
            ]),
            _createElementVNode("div", null, [
              (
                _ctx.question?.type === 'DEFAULT' || _ctx.question?.type === undefined
              )
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item?.answerText), 1))
                : (_ctx.question?.type === 'TRUE_OR_FALSE')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(item.answerText) + " - ", 1),
                        _createElementVNode("strong", null, " ( " + _toDisplayString(item.correctAnswer ? "Verdadeiro" : "Falso") + " ) ", 1)
                      ]),
                      _hoisted_10
                    ]))
                  : (_ctx.question?.type === 'DRAG_AND_DROP')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        innerHTML: item?.answerText
                      }, null, 8, _hoisted_11))
                    : (_ctx.question?.type === 'FILL_IN_THE_BLANKS')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 3,
                          innerHTML: item?.answerText
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128)),
      (_ctx.role === 'TEACHER')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_Button, {
              id: `btn-edit-question-${_ctx.questionIndex}`,
              class: "btn-simple p-button-sm",
              icon: "pi pi-pencil",
              label: _ctx.$t('labels.edit'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToQuestion(_ctx.question.id, _ctx.question?.type)))
            }, null, 8, ["id", "label"]),
            _createVNode(_component_Button, {
              id: `btn-delete-question-${_ctx.questionIndex}`,
              class: "btn-delete p-button-sm",
              icon: "pi pi-trash",
              label: _ctx.$t('labels.delete'),
              loading: _ctx.loadBtn[_ctx.questionIndex],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.confirmModal({
              id: _ctx.question.id,
              index: _ctx.questionIndex,
              type: _ctx.question.type,
            })
          ))
            }, null, 8, ["id", "label", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmDialog, {
      group: `question-${_ctx.questionIndex}`,
      style: { width: '80vw', maxWidth: '700px' }
    }, null, 8, ["group"])
  ]))
}